module.exports = "<div class=\"widgets\">\n\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <ba-card cardTitle=\"Sub County List\" baCardClass=\"with-scroll\">\n        <sub-county-list></sub-county-list>\n      </ba-card>\n    </div>\n\n    <div class=\"col-md-4\">\n      <ba-card cardTitle=\"New Sub County\" baCardClass=\"with-scroll\">\n        <sub-county-form></sub-county-form>\n      </ba-card>\n    </div>\n\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/localization/components/sub-counties/sub-counties.component.html
// module id = 877
// module chunks = 8